import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { AppStreamEnvironment, ErmCapabilityApiClientService } from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  public ermCapabilityApiClient = inject(ErmCapabilityApiClientService);
  public isLoading: WritableSignal<boolean> = signal(false);
  public error = signal<unknown | null>(null);
  public environments = signal<AppStreamEnvironment[] | null>(null);
  async ngOnInit(): Promise<void> {
    await this.loadEnvironments();
  }

  async loadEnvironments(): Promise<void> {
    try {
      this.isLoading.set(true);
      this.error.set(null);
      const getAppStreamEnvironmentsResponse = await this.ermCapabilityApiClient.getAppStreamEnvironments();
      const environments = getAppStreamEnvironmentsResponse?.body?.appStreamEnvironments ?? [];
      this.environments.set(environments);

    } catch (error) {
      this.error.set(error);
      this.environments.set([]);
    } finally {
      this.isLoading.set(false);
    }
  }

  public reload(): void {
    this.loadEnvironments();
  }
}